import { render, staticRenderFns } from "./TalentMatrixAxisUserValuesDialog.vue?vue&type=template&id=611062f3"
import script from "./TalentMatrixAxisUserValuesDialog.vue?vue&type=script&lang=js"
export * from "./TalentMatrixAxisUserValuesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports